module.exports = __webpack_public_path__ + "media/images/team/loraine-ferrer-3534b44887684b5d4333df6a19726359.png";